import React from 'react';
import { IconsPros } from './types';

/**
 * SmartTraffic Icon component
 *
 * @returns JSX.ELEMENT
 */
export const SmartTrafficIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 15 16" data-testid={dataTestId}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.51242 2.89209c-.14262.14667-.18534.36782-.108.56018.07682.19217.25836.31715.46006.31715h1.73882c-.0209 1.66685-1.44703 2.90169-3.10334 4.14294-1.65613-1.24107-3.08214-2.47609-3.10315-4.14294h1.73863c.20136 0 .38307-.12498.46007-.31715.02566-.06329.03824-.13031.03824-.19663 0-.13368-.05064-.26524-.14624-.36355L3.9457.2688c-.3469-.3584-.91152-.3584-1.2579 0L.145989 2.89209c-.142274.14667-.1853351.36782-.1079974.56018.0766484.19217.2585384.31715.4602374.31715H2.23876c.01636 2.46382 1.65234 4.12089 3.43007 5.51431C3.88214 10.6841 2.23772 12.3504 2.23772 14.835v.9936c0 .0948.07424.1714.16588.1714h1.8263c.09164 0 .16605-.0766.16605-.1714v-.9936c0-1.6857 1.43565-2.9294 3.10401-4.1799 1.66853 1.2505 3.10424 2.4942 3.10424 4.1799v.9936c0 .0948.0742.1714.166.1714h1.8261c.0917 0 .1661-.0766.1661-.1714v-.9936c0-2.4844-1.6446-4.1509-3.43131-5.55127 1.77771-1.39342 3.41371-3.05049 3.43011-5.51431h1.7405c.2015 0 .3832-.12498.4604-.31715.0255-.06329.0379-.13031.0379-.19663 0-.13368-.0506-.26524-.1461-.36355L12.3121.2688c-.347-.3584-.9113-.3584-1.2582 0L8.51242 2.89209z"
      />
    </svg>
  );
};
